module.exports = __webpack_public_path__ + "img/8.f9b3fbdd.jpg";